import React, { useCallback, useEffect, useRef } from "react";
import { Collapse } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { closeShortcut } from "../../../store/slices/common/navigation/navigationSlice";

const Shortcut = () => {
  const dispatch = useDispatch();
  const { shortcutOpen } = useSelector((state) => state.navigation);
  const shortcutRef = useRef(null);
  const onClickOutside = useCallback(
    (event) => {
      if (shortcutRef.current && !shortcutRef.current.contains(event.target)) {
        dispatch(closeShortcut());
      }
    },
    [dispatch]
  );
  const onLinkClick = () => {
    dispatch(closeShortcut());
  };
  useEffect(() => {
    document.addEventListener("mousedown", onClickOutside);
    return () => {
      document.removeEventListener("mousedown", onClickOutside);
    };
  }, [onClickOutside]);

  return (
    <Collapse in={shortcutOpen} mountOnEnter={true} unmountOnExit={true}>
      <div id="shortcut" ref={shortcutRef} style={{ display: "block" }}>
        <ul>
          <li>
            <Link onClick={onLinkClick} to="/outlook" title="Inbox" className="jarvismetro-tile big-cubes bg-color-blue">
              <span className="iconbox">
                <i className="fa fa-envelope fa-4x" />
                <span>
                  Mail
                  <span className="label pull-right bg-color-darken">14</span>
                </span>
              </span>
            </Link>
          </li>
          <li>
            <Link onClick={onLinkClick} to="/calendar" className="jarvismetro-tile big-cubes bg-color-orangeDark">
              <span className="iconbox">
                <i className="fa fa-calendar fa-4x" /> <span>Calendar</span>
              </span>
            </Link>
          </li>
          <li>
            <Link onClick={onLinkClick} to="/maps" className="jarvismetro-tile big-cubes bg-color-purple">
              <span className="iconbox">
                <i className="fa fa-map-marker fa-4x" /> <span>Maps</span>
              </span>
            </Link>
          </li>
          <li>
            <Link onClick={onLinkClick} to="/misc/invoice" className="jarvismetro-tile big-cubes bg-color-blueDark">
              <span className="iconbox">
                <i className="fa fa-book fa-4x" />
                <span>
                  Invoice
                  <span className="label pull-right bg-color-darken">99</span>
                </span>
              </span>
            </Link>
          </li>
          <li>
            <Link onClick={onLinkClick} to="/views/gallery" className="jarvismetro-tile big-cubes bg-color-greenLight">
              <span className="iconbox">
                <i className="fa fa-picture-o fa-4x" /> <span>Gallery </span>
              </span>
            </Link>
          </li>
          <li>
            <Link onClick={onLinkClick} to="/views/profile" className="jarvismetro-tile big-cubes selected bg-color-pinkDark">
              <span className="iconbox">
                <i className="fa fa-user fa-4x" /> <span>My Profile </span>
              </span>
            </Link>
          </li>
        </ul>
      </div>
    </Collapse>
  );
};

export default Shortcut;
